import React, { useState, useEffect,useRef } from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { faPlus, faInr, faMinus } from '@fortawesome/free-solid-svg-icons';
import Skeleton from '@mui/material/Skeleton';
import { Button } from '@mui/material';
import ImageComponents from '../../../Shared/ImageComponents';
import NetbankingRecurring from '../../PaymentMode/Components/NetBanking/NetBankingRecurring';
import PlanAccordion from '../../PaymentMode/Components/CommonDetails/PlanAccordion';
import PaymentError from '../../PaymentSteps/PaymentError';
import PaymentSteps from '../../PaymentSteps/PaymentStepsRecurring';
import PaymentStepsForOtm from '../../PaymentSteps/PaymentStepsForOtm';
import AadharRecurring from '../../PaymentMode/Components/Aadhar/AadharRecurring';
import EmandateOnDebit from '../../PaymentMode/Components/DebitCard/EmandateOnDebit';
import UpiDetailsRecurring from '../../PaymentMode/Components/UpiPayments/UpiDetailsRecurring';
import CreditCardSI from '../../PaymentMode/Components/CreditCard/CreditCardSI';
import CustomizedDialogs from '../../../Shared/CustomDialogs';
import SkipAutoPay from '../../../Shared/SkipAutoPay';
import CreditCardRecurring from '../../PaymentMode/Components/CreditCard/CreditCardRecurring';


export default function PaymentAccordionRecurring({showDialog, otmpayment}) {
  const [showSkipAutoPay, setShowSkipAutoPay] = useState(false);
  const [isShowLess, setIsShowLess] = useState(true);
  const [isShowPlanDetail, setIsShowPlanDetail] = useState(true);
  const [isShowProposerDetail, setShowProposerDetail] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const [value, setValue] = useState(0);
  const [payModes, setPayModes] = useState([]);
  const [payModesToPass, setPayModesToPass] = useState([]);
  const [apiData, setApiData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [eligibleModes, setEligibleModes] = useState([]);
    
  
    const certifiedLogosStyle = {
      fontSize: '12px',
      color: '#0065FF', 
      overflow: 'hidden',
      display: 'flex',
      // position: 'fixed',
      justifyContent: 'space-between', // Align items to the edges
      alignItems: 'center', // Vertically center items
      padding: '10px',
      width: '100%',
    };
 
   
  useEffect(() => {
    const fetchData = async () => {
      try {
        const queryParameters = new URLSearchParams(window.location.search);
        const order = queryParameters.get("orderNo");
        const var1 = queryParameters.get("var1");
        const var2 = queryParameters.get("var2");
        const temp = { orderNo: order , isMobileView: true};

        const response = await fetch(`/pay/securePayment/details/paymentModes?var1=${var1}&var2=${var2}&isRecurring=true`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(temp),
        });
  
        const data = await response.json();
        setApiData(data);
        setIsLoading(false);
        const extractedPayModes = data.beans.payModes;
        const codeList = extractedPayModes.map(method => method.code);
        setPayModes(codeList);
        setPayModesToPass(data.beans.payModes);
        setEligibleModes(data.eligibleModes);
        console.log(extractedPayModes);
      } catch (error) {
        console.error('API request error:', error);
      }
    };

    if (!apiData) {
      fetchData();
    }
  }, [apiData]);

  useEffect(() => {
    if (!apiData || !eligibleModes || eligibleModes.length === 0) {
      return;
    }

    const getFirstValidIndex = () => {
      for (let i = 0; i < eligibleModes.length; i++) {
        const mode = eligibleModes[i];
        if (mode.code === 'UPI_EMANDATE') {
          const isUpiEmandateAvailableDisplayMode =
            apiData.showUpiEmandateIntent || apiData.showEmanQrCode || apiData.isEligibleForUpiCollectEman;
          if (!isUpiEmandateAvailableDisplayMode) {
            continue;
          }
        }
        return i;
      }
      return -1;
    };

    const firstValidIndex = getFirstValidIndex();
    if (firstValidIndex === -1) {
      return;
    }

    if (value < firstValidIndex || value >= eligibleModes.length) {
      setValue(firstValidIndex);
    }
  }, [eligibleModes, apiData, value]);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : null);
   
  };

  const isParentOtmSuccess =
    !!apiData &&
    (apiData.isParentOtmSuccess === true || apiData.beans?.isParentOtmSuccess === true);

  return (
    <>
      {isLoading ? (
        <div>
          <Skeleton animation="wave" className="md:block" height={600} variant="text" />
          {/* Add more skeleton components as needed */}
        </div>
      ) : (
        <div className='card-view'>
          <div className='mt-10 lg:hidden'>{otmpayment ? <PaymentStepsForOtm/> : <PaymentSteps/>}</div>
         <div className="payment-mob-view">
          <table className='w-full' >
                 {apiData.planDetails.map((insurer, index) => (
    <React.Fragment key={index}>
    <tr style={{ verticalAlign: 'top' }}>
     <td colSpan="2" style={{ verticalAlign: 'top' }}>
  <img class="source-logo"
    src={
      /^https?:\/\//i.test(insurer.insurerLogo)
        ? insurer.insurerLogo
        : `./images/${insurer.insurerLogo}`
    } 
    alt={insurer.insurerName} 
    style={{ maxWidth: '100%', height: 'auto' }} 
  />
</td>
      <td colSpan="2" style={{ verticalAlign: 'top' }}>
        <div className='paying-card-head'>
          <div className='flex items-center justify-end'>
              <p>
                <span>Premium</span>
                <strong className='block'><i className='text-xs'><FontAwesomeIcon icon={faInr} /></i> {insurer.txAmount}</strong>
              </p>
              
          </div>
         </div>
      </td>
    </tr>
    <tr>
        <td colSpan="4">
            {insurer.planName && (
                <div className='plan-name-below-logo' style={{ marginTop: '8px', marginBottom: '8px', fontSize: '14px', wordBreak: 'break-word', whiteSpace: 'normal', display: 'flex' }}>
                    <span style={{ color: '#888', fontSize: '14px', minWidth: '90px', flexShrink: 0 }}>Plan Name: </span><span style={{ fontSize: '14px' }}>{insurer.planName}</span>
                </div>
            )}
            {insurer.uinNo && insurer.uinNo !== 'null' && (
                <div className='uin-below-logo' style={{ marginTop: '8px', marginBottom: '8px', fontSize: '14px', wordBreak: 'break-word', whiteSpace: 'normal', display: 'flex' }}>
                    <span style={{ color: '#888', fontSize: '14px', minWidth: '90px', flexShrink: 0 }}>UIN No: </span><span style={{ fontSize: '14px' }}>{insurer.uinNo}</span>
                </div>
            )}
        </td>
    </tr>
    {index < apiData.planDetails.length - 1 && (
        <tr>
            <td colSpan="4">
                <hr style={{ margin: '8px 0', border: 'none', borderTop: '1px solid #ccc' }} />
            </td>
        </tr>
    )}
    </React.Fragment>
  ))}
                        {!isShowLess  && (
                         <>
                        <tr>
                            <td colSpan="2">
                                <div className='border-tab'></div>
                            </td>
                            <td colSpan="2">
                                <div className='border-tab'></div>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2">
                                <p>Premium amount</p>
                            </td>
                            <td colSpan="2">
                                <strong className='block'><i className='text-xs'><FontAwesomeIcon icon={faInr} /></i>{apiData.totalAmount} </strong>
                            </td>
                        </tr>
                      
                        </>
                    )}
                    </table>
         </div>
          <div className='payment-accordion-box debit-card-box'>
            <h4 className='my-4' style={{ fontWeight: 'bold', marginLeft: '10px' }}>Choose payment mode</h4>
            {apiData.retry && <PaymentError retry = {apiData.retry} style={{ marginBottom: '16px' }}  />}

            {eligibleModes.map((mode, index) => {
            switch(mode.code){
                case 'EMANDATE_NB':
                return (<Accordion expanded={expanded === 'netbanking'} onChange={handleChange('netbanking')} className='shadow-none' >
                          <AccordionSummary
                            expandIcon={<FontAwesomeIcon icon={expanded === 'netbanking' ? faMinus : faPlus} />}
                            aria-controls="panel3bh-content"
                            id="panel3bh-header">
                            <Typography>
                              <ImageComponents name={'netbanking'} /> Netbanking
                            </Typography>
                          </AccordionSummary>
                          <AccordionDetails>
                          <NetbankingRecurring payModesToPass={payModesToPass} displayOrderNo={apiData.encryptParentOrderNo} eMandateNo={apiData.eMandateNo}
                                     maxAmountLimit={apiData.maxAmountLimit} parentOrderNo={apiData.parentOrderNo} order_id={apiData.order_id} cust_id={apiData.cust_id} mid={apiData.mid}
                                     expire_at={apiData.expire_at} orderNo={apiData.encryptParentOrderNo} productId = {apiData.productId}
                                     isParentOtmSuccess={isParentOtmSuccess} />
                          </AccordionDetails>
                        </Accordion>);
                break;
                 case 'EMANDATE_ADHR':
                    return (<Accordion expanded={expanded === 'pos'} onChange={handleChange('pos')} className='shadow-none' >
                              <AccordionSummary
                                expandIcon={<FontAwesomeIcon icon={expanded === 'pos' ? faMinus : faPlus} />}
                                aria-controls="panel3bh-content"
                                id="panel3bh-header">
                                <Typography>
                                  <ImageComponents name={'pos'} /> Aadhar Card
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                              <AadharRecurring payModesToPass={payModesToPass} displayOrderNo={apiData.encryptParentOrderNo} eMandateNo={apiData.eMandateNo}
                                         maxAmountLimit={apiData.maxAmountLimit} parentOrderNo={apiData.parentOrderNo} order_id={apiData.order_id} cust_id={apiData.cust_id} mid={apiData.mid}
                                         expire_at={apiData.expire_at} orderNo={apiData.encryptParentOrderNo} productId = {apiData.productId}
                                         isParentOtmSuccess={isParentOtmSuccess} />
                              </AccordionDetails>
                            </Accordion>);
                    break;
                    case 'RECURRING_DC':
                        return (<Accordion expanded={expanded === 'debitCard'} onChange={handleChange('debitCard')} className='shadow-none' >
                                  <AccordionSummary
                                    expandIcon={<FontAwesomeIcon icon={expanded === 'debitCard' ? faMinus : faPlus} />}
                                    aria-controls="panel3bh-content"
                                    id="panel3bh-header">
                                    <Typography>
                                      <ImageComponents name={'creditCard'} /> Debit Card
                                    </Typography>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                   <EmandateOnDebit payModesToPass={payModesToPass} displayOrderNo={apiData.encryptParentOrderNo} eMandateNo={apiData.eMandateNo}
                                       maxAmountLimit={apiData.maxAmountLimit} parentOrderNo={apiData.parentOrderNo} order_id={apiData.order_id} cust_id={apiData.cust_id} mid={apiData.mid}
                                       expire_at={apiData.expire_at} sidcBankNote={apiData.sidcBankNote} secret={apiData.secret} cardDownBanks = {apiData.cardDownBanks}
                                       productId = {apiData.productId} srcSupplierId = {apiData.srcSupplierId} displayMode = {apiData.displayMode} orderNo={apiData.orderNo}
                                       isParentOtmSuccess={isParentOtmSuccess} />
                                  </AccordionDetails>
                                </Accordion>);
                        break;
                      case 'UPI_EMANDATE':
                        const isUpiEmandateAvailableDisplayMode = apiData.showUpiEmandateIntent || apiData.showEmanQrCode || apiData.isEligibleForUpiCollectEman;
                        if (!isUpiEmandateAvailableDisplayMode) {
                          return null;
                        }
                        return (<Accordion expanded={expanded === 'UpiIcon'} onChange={handleChange('UpiIcon')} className='shadow-none'>
                            <AccordionSummary
                              expandIcon={<FontAwesomeIcon icon={expanded === 'UpiIcon' ? faMinus : faPlus} />}
                              aria-controls="panel3bh-content"
                              id="panel3bh-header">
                              <Typography>
                                <ImageComponents name={'UpiIcon'} /> UPI Emandate
                              </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <UpiDetailsRecurring payMode={apiData.eligibleModes[index]} productId = {apiData.productId}
                               txAmount = {apiData.amount} showEmanQrCode = {apiData.showEmanQrCode} showUpiEmandateIntent={apiData.showUpiEmandateIntent} isEligibleForUpiCollectEman={apiData.isEligibleForUpiCollectEman}
                               isParentOtmSuccess={isParentOtmSuccess} />
                            </AccordionDetails>
                          </Accordion>);
                        break;
                         case 'SI_CC':
                    return (<Accordion expanded={expanded === 'creditCard'} onChange={handleChange('creditCard')} className='shadow-none'>
                              <AccordionSummary
                                expandIcon={<FontAwesomeIcon icon={expanded === 'creditCard' ? faMinus : faPlus} />}
                                aria-controls="panel1bh-content"
                                id="panel1bh-header">
                                <Typography>
                                  <ImageComponents name={'creditCard'} /> Credit Card
                                </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                              <CreditCardRecurring  secret={apiData.secret} cardDownBanks = {apiData.cardDownBanks}
                                     productId = {apiData.productId} srcSupplierId = {apiData.srcSupplierId} displayMode = {apiData.displayMode}
                                     isParentOtmSuccess={isParentOtmSuccess} />
                              </AccordionDetails>
                            </Accordion>);
                    break;	

              default:
                break; 
            }
          })}
           
          <PlanAccordion />
          {showDialog && (<button  onClick={() => setShowSkipAutoPay(true)} className='skip-autopay-btn'>Skip Autopay Registration</button> )}
                
          </div>
          <div style={certifiedLogosStyle} className="certified-logos hideSmall">
              <p className="left">
                <a href="https://www.policybazaar.com/legal-and-admin-policies/" target="_blank" rel="noopener noreferrer">
                  Privacy Policy
                </a>
                {'  |  '}
                <a href="https://www.policybazaar.com/legal-and-admin-policies/#termsofuse" target="_blank" rel="noopener noreferrer">
                  Terms & Conditions
                </a>
                {'  |  '}
                <a href="https://payment.policybazaar.com/pay/faq.jsp" target="_blank" rel="noopener noreferrer">
                  FAQ
                </a>
              </p>
              <p className="right rightOne">
                <a href="https://www.5tattva.com/verify/ftzdkix4sq" target="_blank" rel="noopener noreferrer">
              
                  <img
                    src="./images/pci-dss-certified@2x.png"
                    alt="PCI DSS Certified"
                    width="84"
                  />
                </a>
              </p>
        </div>
        </div>
      )}
      
        {showSkipAutoPay ? <CustomizedDialogs  className='razor-pay-dialog'  open={showSkipAutoPay} handleClose={() => setShowSkipAutoPay(false)}>
        <SkipAutoPay  handleCloseDialog={() => setShowSkipAutoPay(false)}/>
      </CustomizedDialogs>
      : null}
       
    </>
  );
}

